import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from 'environments/environment';
import {PannellumStadiumCamera} from 'app/models/pannellum-stadium-camera';
import {CompetitionService} from 'app/services/competition.service';
import {Stadium} from 'app/models/stadium';

@Injectable({
    providedIn: 'root'
})
export class StadiumCamerasService {

    private apiUrl = environment.api.url + environment.api.content.url;

    constructor(private http: HttpClient, private competitionService: CompetitionService) {}

    getAll(): Observable<Stadium> {
        let params = new HttpParams();
        params = params.append('competition', this.competitionService.getCompetitionId());
        params = params.append('op', environment.api.content.type.assets.op);
        params = params.append('source', environment.api.content.type.assets.stadium);

        return this.http
            .get<any>(this.apiUrl, {params})
            .pipe(
                map(res => {
                    const stadium = <Stadium> res.Items[0]
                    stadium.pannellumStadiumCamera = this.generateCameraIds(stadium.pannellumStadiumCamera)
                    return stadium
                }),
                catchError(err => throwError(err || 'ServerErr'))
            );
    }

    getDefaultPannellumStadiumCameras(): Observable<PannellumStadiumCamera[]> {
        return this.http
            .get<PannellumStadiumCamera[]>(environment.api.stadiumCamera.url)
            .pipe(
                map(res => res.map(element => <PannellumStadiumCamera> element)),
                catchError(err => throwError(err || 'ServerErr'))
            );
    }

    create(stadium: Stadium): Observable<Stadium> {
        return this.http
            .post<Stadium>(this.apiUrl, this.cleanForSave(stadium))
            .pipe(
                map(res => <Stadium> res),
                catchError(err => throwError(err || 'ServerErr'))
            );
    }

    update(stadium: Stadium): Observable<Stadium> {
        const cameras = [...stadium.pannellumStadiumCamera]
        return this.http
            .put<Stadium>(this.apiUrl, this.cleanForSave(stadium))
            .pipe(
                map(res => {
                    const stadium = <Stadium> res
                    stadium.pannellumStadiumCamera = cameras
                    return stadium
                }),
                catchError(err => throwError(err || 'ServerErr'))
            );
    }

    private cleanForSave(stadium: Stadium): Stadium {
        const cameras = []
        for (const camera of stadium.pannellumStadiumCamera) {
            const cameraCopy: any = {...camera}
            delete cameraCopy.id
            delete cameraCopy.div
            cameras.push(cameraCopy)
        }
        return {...stadium, pannellumStadiumCamera: cameras}
    }

    private generateCameraIds(cameras: PannellumStadiumCamera[]): PannellumStadiumCamera[] {
        for (let camera of cameras) {
            camera.id = `${Math.random().toString(36).substring(2)}`
            // backwards compatibility: posName used to be inside createTooltipArgs, now it's in the PannellumStadiumCamera
            if (camera.createTooltipArgs.posName !== undefined) {
                camera.posName = camera.createTooltipArgs.posName
                delete camera.createTooltipArgs.posName
            }
        }
        return cameras
    }
}
